import React, { FC, useEffect, useState, useRef, useContext } from 'react'
import moment from 'moment'
import history from '../../history'
import { isMobile, isTablet } from 'react-device-detect'
import { Modal } from 'react-responsive-modal'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useParams,
  useLocation,
} from 'react-router-dom'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import firebase from 'firebase/app'

import GenericMobileTopNavigation from '../../GenericComponents/GenericMobileTopNavigation'
import GenericBackgroundLayer from '../../GenericComponents/GenericBackgroundLayer'
import GenericBackButton from '../../GenericComponents/GenericBackButton'
import GenericMainCart from '../../GenericComponents/GenericMainCard'
import GenericTextSpan from '../../GenericComponents/GenericTextSpan'
import GenericButton from '../../GenericComponents/GenericButton'
import GenericLogo from '../../GenericComponents/GenericLogo'

import NavigationBar from '../NavigationBar/NavigationBar'
import Loader from '../Loader/Loader'

import { getSingleVideo } from '../../Api/videoApi'
import { getUserData } from '../../Api/backendApi'

import { getAllAlbumVideos } from '../../Api/videoApi'

import AppContext from '../../context/appContext'
import { arrayRemove } from '../../utils/ArrayHelpers'

import AlbumCarousel from './views/AlbumCarousel'
import GenericRow from '../../GenericComponents/GenericRow'
import GenericColumn from '../../GenericComponents/GenericColumn'
import DocumentationMode from './views/DocumentationMode'
import FavoritesMode from './views/FavoritesMode'

import { AlbumCard, AlbumName } from '../MainScreen/styles/MainScreenStyles'

import { AlbumTile } from './style/AlbumScreenStyle'
import GenericIcon from '../../GenericComponents/GenericIcon'
import ContactIcon from '../../assets/REDESIGN_Assets/AlbumScreen/contact-icon.svg'

import { AiFillHeart } from 'react-icons/ai'
import timeIcon from '../../assets/REDESIGN_Assets/AlbumScreen/time-icon.svg'
import documentationIcon from '../../assets/REDESIGN_Assets/AlbumScreen/training-documentation-dark.svg'
import ContactModal from './views/ContactModal'
import Navigation from '../Challenges/components/Navigation/Navigation'

interface AlbumScreenPropsInterface {}

const AlbumScreen: FC<AlbumScreenPropsInterface> = () => {
  const appContext = useContext(AppContext)
  const { promiseInProgress } = usePromiseTracker()

  const [user, setUser] = useState(Object)
  const [videos, setVideos] = useState(Object)
  const [albumName, setAlbumName] = useState('')
  const [pdfName, setPdfName] = useState('')
  const [pdfItems, setPdfItems] = useState([])
  const [pdfUrls, setPdfUrls] = useState([])
  const [isModalOpen, setModalOpen] = useState(false)
  const [isDocumentationModeOn, setDocumentationModeOn] = useState(false)
  const [favoritesMode, setFavoritesMode] = useState(false)

  let { albumId } = useParams()
  let location = useLocation()

  useEffect(() => {
    obtainUser()
    getAlbumName()
    obtainAlbumVideos()

    location && !location.state.challengeMode && getPdfName()
  }, [])

  useEffect(() => {
    if (pdfName !== null) {
      obtainFirebase(pdfName)
    }
  }, [pdfName])

  const modalStyles = {
    closeButton: {
      display: 'none',
    },
    modal: {
      maxWidth: 'unset',
      width: isMobile ? '95vw' : '55vw',
      overflow: 'unset',
      left: '0',
      boxsizing: 'border-box',
      margin: isMobile ? 'auto' : 'unset',
      borderRadius: '30px',
    },
  }

  const obtainFirebase = (name: string) => {
    const storage = firebase.storage()
    let tempArr: any = []
    const storageRef = storage.ref()
    var imagesRef = storageRef.child(name)

    imagesRef
      .listAll()
      .then(async (res) => {
        res.items.forEach(async (item: any) => {
          setPdfItems([...pdfItems, item.name])

          const itemUrl = await createDownloadableLink(item)
        })
      })
      .catch((e) => {})

    const createDownloadableLink = async (item: any) => {
      var downloadPDF = storageRef.child(item.location.path)
      let itemUrl
      let tempObj: any = {}

      downloadPDF
        .getDownloadURL()
        .then((url) => {
          let slicedName
          let onlyName

          if (item.name.includes('_')) {
            itemUrl = url
            slicedName = item.name.split('_')
            onlyName = slicedName[1].slice(0, -4)
          } else {
            itemUrl = url
            slicedName = item.name.split('-')
            onlyName = slicedName[1].slice(0, -4)
          }

          tempObj = {
            url: url,
            name: onlyName,
            order: parseInt(slicedName[0]),
          }

          tempArr = [...tempArr, tempObj]

          setPdfUrls(tempArr)

          return tempObj
        })

        .catch(function (error) {
          switch (error.code) {
            case 'storage/object-not-found':
              // File doesn't exist
              break

            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break

            case 'storage/canceled':
              // User canceled the upload
              break

            case 'storage/unknown':
              // Unknown error occurred, inspect the server response
              break
          }
        })
    }
  }

  const obtainUser = async () => {
    if (appContext.appState.user) {
      setUser(appContext.appState.user)
    }

    const user = await trackPromise(getUserData())
    setUser(user)
    appContext.updateAppState('user', user)
  }

  const getPdfName = () => {
    if (location.state.pdfFolder !== '') {
      setPdfName(location.state.pdfFolder.toLowerCase())
    } else {
      setPdfName(null)
    }
  }

  const obtainAlbumVideos = async () => {
    if (
      appContext.appState.albumVideos &&
      appContext.appState.albumVideos[location.state.albumName] &&
      albumId
    ) {
      setVideos(appContext.appState.albumVideos[location.state.albumName][0])

      setVideos(appContext.appState.albumVideos[location.state.albumName][0])

      const videos = await getAllAlbumVideos(albumId)

      appContext.updateAppState(`albumVideos`, {
        ...appContext.appState.albumVideos,
        [location.state.albumName]: [videos],
      })
      setVideos(videos)
    } else {
      const videos = await trackPromise(getAllAlbumVideos(albumId))
      setVideos(videos)

      if (!appContext.appState.albumVideos) {
        appContext.updateAppState(`albumVideos`, {
          [location.state.albumName]: [videos],
        })
      } else {
        appContext.updateAppState(`albumVideos`, {
          ...appContext.appState.albumVideos,
          [location.state.albumName]: [videos],
        })
      }
    }
  }

  const getAlbumName = () => {
    setAlbumName(location.state.albumName)
  }

  return (
    <GenericBackgroundLayer
      fDir={'column'}
      justify={'flex-start'}
      align={'center'}
      className={`${
        appContext.appState.theme == 'light' ? 'light' : 'standard'
      } album-screen`}
    >
      {!location.state.challengeMode ? (
        <NavigationBar
          isPlayerView={false}
          backButtonAction={
            isDocumentationModeOn
              ? () => setDocumentationModeOn(false)
              : () => history.push('/trening')
          }
        />
      ) : (
        <Navigation />
      )}
      {isMobile && (
        <GenericMobileTopNavigation
          isPlayerView={false}
          handleClick={
            isDocumentationModeOn
              ? () => setDocumentationModeOn(false)
              : () =>
                  history.push(
                    location.state.challengeMode ? '/wyzwania' : '/trening'
                  )
          }
          dietCartClick={null}
        />
      )}
      {isDocumentationModeOn ? (
        <DocumentationMode albumName={albumName} pdfUrls={pdfUrls} />
      ) : favoritesMode ? (
        <FavoritesMode
          albumName={albumName}
          favorites={videos && videos.favorite_videos}
          history={history}
          albumId={albumId}
          challengeMode={location.state.challengeMode}
          videos={videos}
        />
      ) : (
        <>
          <GenericRow
            margin={'3% 0 7% 0'}
            left={'20px'}
            width={isMobile ? '90%' : '90%'}
            justify={'space-between'}
          >
            {albumName && albumName.includes(';') ? (
              <div>
                <GenericTextSpan
                  className={`${
                    appContext.appState.theme == 'light' ? 'light' : ''
                  }`}
                  tAlign="left"
                  display={'block'}
                  width={'100%'}
                  fSize={isMobile ? '1.7rem' : '2.5rem'}
                  fWeight={'bold'}
                >
                  {albumName.split(';')[0]}
                </GenericTextSpan>
                <GenericTextSpan
                  className={`${
                    appContext.appState.theme == 'light' ? 'light' : ''
                  }`}
                  tAlign="left"
                  display={'block'}
                  width={'100%'}
                  fSize={isMobile ? '1.5rem' : '1.5rem'}
                >
                  {albumName.split(';')[1]}
                </GenericTextSpan>
              </div>
            ) : (
              <GenericTextSpan
                className={`${
                  appContext.appState.theme == 'light' ? 'light' : ''
                }`}
                tAlign="left"
                fSize={isMobile ? '1.7rem' : '2.5rem'}
                fWeight={'bold'}
                display={'block'}
                width={'100%'}
              >
                {albumName}
              </GenericTextSpan>
            )}

            {pdfUrls.length || location.state.contactEmail ? (
              <GenericRow
                justify={'center'}
                className={'pointer'}
                width={'50%'}
              >
                {location.state.contactEmail && (
                  <GenericRow
                    style={{ display: 'flex' }}
                    onClick={() => setModalOpen(true)}
                  >
                    {!isMobile && (
                      <GenericTextSpan
                        className={`${
                          appContext.appState.theme == 'light' ? 'light' : ''
                        }`}
                        fSize={'1rem'}
                      >
                        Kontakt
                      </GenericTextSpan>
                    )}
                    <GenericIcon
                      margin={isMobile ? '0 15% 0 3%' : '0 0 0 3%'}
                      width={isMobile ? '5vw' : '1vw'}
                      height={isMobile ? '5vw' : '1vw'}
                      src={ContactIcon}
                      onClick={() => setModalOpen(true)}
                    />
                  </GenericRow>
                )}

                {pdfUrls.length ? (
                  <GenericRow
                    style={{ display: 'flex' }}
                    onClick={() => setDocumentationModeOn(true)}
                  >
                    {!isMobile && (
                      <GenericTextSpan
                        className={`${
                          appContext.appState.theme == 'light' ? 'light' : ''
                        }`}
                        fSize={'1rem'}
                      >
                        Dokumentacja treningów
                      </GenericTextSpan>
                    )}
                    <GenericIcon
                      margin={isMobile ? '0 15% 0 3%' : '0 0 0 3%'}
                      width={isMobile ? '5vw' : '1vw'}
                      height={isMobile ? '5vw' : '1vw'}
                      src={documentationIcon}
                      onClick={() => setDocumentationModeOn(true)}
                    />
                  </GenericRow>
                ) : null}
              </GenericRow>
            ) : null}
            {!favoritesMode && (
              <GenericRow
                className="pointer"
                width={'33%'}
                onClick={() => setFavoritesMode(true)}
              >
                <GenericTextSpan>Ulubione</GenericTextSpan>
                <AiFillHeart className="favorites-icon" />
              </GenericRow>
            )}
          </GenericRow>

          {videos && videos.api_message && (
            <GenericRow
              width={'90%'}
              margin={'3% 0'}
              padding={'1%'}
              className="info-banner"
            >
              <GenericTextSpan
                color={'rgb(52, 33, 82)'}
                fSize={'1.4rem'}
                fWeight="bold"
              >
                {videos.api_message && videos.api_message}
              </GenericTextSpan>
            </GenericRow>
          )}

          <GenericRow
            width={isMobile ? '90%' : '90%'}
            className="album-container"
            padding={'0 1%'}
            justify="flex-start"
            height={
              isMobile
                ? 'unset'
                : (videos && videos.video_for_today) ||
                  (videos && videos.video_for_next_day)
                ? '15vh'
                : 'unset'
            }
            wrap={isMobile ? 'wrap' : 'unset'}
          >
            {videos && videos.video_for_today && (
              <GenericColumn
                width={isMobile ? '100%' : '50%'}
                align={'center'}
                className="album-screen-tile"
                // left={isMobile ? '5%' : '5px'}
              >
                <GenericTextSpan
                  className={`${
                    appContext.appState.theme == 'light' ? 'light' : ''
                  }`}
                  fSize={'1.4rem'}
                  display={'block'}
                  width={'100%'}
                  tAlign={'left'}
                  margin={'0% 0 2% 0%'}
                >
                  Trening na dziś
                </GenericTextSpan>

                <AlbumTile
                  className={
                    videos.video_for_today.is_locked
                      ? ' album-tile'
                      : 'active album-tile'
                  }
                  onClick={
                    videos && !videos.video_for_today.is_locked
                      ? () => {
                          history.push({
                            pathname: `/video/${videos.video_for_today.vimeo_video_id}`,
                            state: {
                              albumName: albumName,
                              videoOrder: videos.video_for_today.video_order,
                              isIntro: videos.video_for_today.is_intro,
                              videoId: videos.video_for_today.vimeo_video_id,
                              albumId: albumId,
                              challengeMode: location.state.challengeMode,
                              videoName: videos.video_for_today.name,
                              isFav: videos.favorite_videos.some(
                                (v: any) =>
                                  v.video_id ===
                                  videos.video_for_today.vimeo_video_id
                              ),
                            },
                          })
                        }
                      : null
                  }
                >
                  <GenericColumn width={'33%'}>
                    <GenericIcon
                      borderRadius={'19px'}
                      backgroundSize={'cover'}
                      src={videos.video_for_today.pictures.sizes[4].link}
                      width={'100%'}
                      height={'10vh'}
                    />
                  </GenericColumn>
                  <GenericColumn
                    width={'66%'}
                    align={'flex-start'}
                    justify={'space-between'}
                    height={'100%'}
                    padding={'3% 5%'}
                  >
                    <GenericTextSpan
                      width={'100%'}
                      fSize={'0.8rem'}
                      color={
                        videos && videos.video_for_today.badge == ''
                          ? 'white'
                          : '#a1ff68'
                      }
                      tAlign={
                        videos && videos.video_for_today.badge == ''
                          ? 'left'
                          : 'right'
                      }
                    >
                      {videos && videos.video_for_today.badge == ''
                        ? 'Trening na dziś'
                        : videos.video_for_today.badge}
                    </GenericTextSpan>
                    <GenericTextSpan
                      fSize={isMobile ? '1rem' : '1.1rem'}
                      fWeight={'bold'}
                    >
                      {videos && videos.video_for_today.name}
                    </GenericTextSpan>
                    <GenericRow justify={'flex-start'}>
                      <GenericIcon
                        src={timeIcon}
                        width={
                          isMobile && !isTablet
                            ? '3vw'
                            : isTablet
                            ? '1.2vw'
                            : '0.75vw'
                        }
                        height={
                          isMobile && !isTablet
                            ? '3vw'
                            : isTablet
                            ? '1.2vw'
                            : '0.75vw'
                        }
                        margin={'0 5% 0 0'}
                      ></GenericIcon>
                      <GenericTextSpan>
                        {Math.floor(
                          videos && videos.video_for_today.duration / 60
                        )}{' '}
                        minut
                      </GenericTextSpan>
                    </GenericRow>
                  </GenericColumn>
                </AlbumTile>
              </GenericColumn>
            )}
            {videos && videos.video_for_next_day && (
              <GenericColumn
                width={isMobile ? '100%' : '50%'}
                align={'center'}
                className="album-screen-tile"
                // left={isMobile ? '5%' : '5px'}
                margin={isMobile ? '5% 0 0 0' : '0 0 0 0'}
              >
                <GenericTextSpan
                  className={`${
                    appContext.appState.theme == 'light' ? 'light' : ''
                  }`}
                  fSize={'1.4rem'}
                  display={'block'}
                  width={'100%'}
                  tAlign={'left'}
                  margin={'0% 0 2% 0%'}
                >
                  Trening na kolejny dzień
                </GenericTextSpan>

                <AlbumTile
                  className={
                    videos && videos.video_for_next_day.is_locked
                      ? ' album-tile'
                      : 'active album-tile'
                  }
                  onClick={
                    videos && !videos.video_for_next_day.is_locked
                      ? () => {
                          history.push({
                            pathname: `/video/${videos.video_for_next_day.vimeo_video_id}`,
                            state: {
                              albumName: albumName,
                              videoOrder: videos.video_for_next_day.video_order,
                              isIntro: videos.video_for_next_day.is_intro,
                              videoId: videos.video_for_next_day.vimeo_video_id,
                              albumId: albumId,
                              challengeMode: location.state.challengeMode,
                              videoName: videos.video_for_next_day.name,
                              isFav: videos.favorite_videos.some(
                                (v: any) =>
                                  v.video_id ===
                                  videos.video_for_next_day.vimeo_video_id
                              ),
                            },
                          })
                        }
                      : null
                  }
                >
                  <GenericColumn width={'32%'}>
                    <GenericIcon
                      borderRadius={'19px'}
                      src={
                        videos &&
                        videos.video_for_next_day.pictures.sizes[4].link
                      }
                      width={'100%'}
                      height={'10vh'}
                      backgroundSize={'cover'}
                    />
                  </GenericColumn>
                  <GenericColumn
                    width={'66%'}
                    padding={'3% 5%'}
                    align={'flex-start'}
                    justify={'space-between'}
                    height={'100%'}
                  >
                    {videos && videos.video_for_next_day.is_locked && (
                      <GenericTextSpan
                        color={'#a1ff68'}
                        display={'block'}
                        width={'100%'}
                        tAlign={'right'}
                        fSize={'0.8rem'}
                      >
                        Niedostępny
                      </GenericTextSpan>
                    )}
                    <GenericTextSpan
                      fSize={isMobile ? '1rem' : '1.1rem'}
                      fWeight={'bold'}
                    >
                      {videos && videos.video_for_next_day.name}
                    </GenericTextSpan>
                    <GenericRow justify={'flex-start'}>
                      <GenericIcon
                        src={timeIcon}
                        width={
                          isMobile && !isTablet
                            ? '3vw'
                            : isTablet
                            ? '1.2vw'
                            : '0.75vw'
                        }
                        height={
                          isMobile && !isTablet
                            ? '3vw'
                            : isTablet
                            ? '1.2vw'
                            : '0.75vw'
                        }
                        margin={'0 5% 0 0'}
                      ></GenericIcon>
                      <GenericTextSpan>
                        {Math.floor(
                          videos && videos.video_for_next_day.duration / 60
                        )}{' '}
                        minut
                      </GenericTextSpan>
                    </GenericRow>
                  </GenericColumn>
                </AlbumTile>
              </GenericColumn>
            )}
          </GenericRow>

          <AlbumCarousel
            albumName={albumName && albumName}
            albumId={albumId && albumId}
            videos={videos && videos}
            challengeMode={location.state.challengeMode}
          />

          {!isMobile && window.innerHeight > 1000 && (
            <GenericLogo
              position={'absolute'}
              bottom={'5vh'}
              theme={appContext.appState.theme == 'light' ? 'light' : null}
            />
          )}
        </>
      )}
      {promiseInProgress &&
        (!appContext.appState.albumVideos ||
          (appContext.appState.albumVideos &&
            !appContext.appState.albumVideos[location.state.albumName])) && (
          <Loader />
        )}
      <Modal
        open={isModalOpen}
        animationDuration={700}
        onClose={() => setModalOpen(false)}
        center
        styles={modalStyles}
      >
        <ContactModal
          contactAdress={location.state.contactEmail}
          closeModal={() => setModalOpen(false)}
        />
      </Modal>
    </GenericBackgroundLayer>
  )
}

export default AlbumScreen
